import MenuIcon from "@mui/icons-material/Menu";
import { Toolbar, Typography } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../hooks/useAppSelector";
import { toggleDrawer } from "../../store/drawer.slice";
import LanguageSelect from "./LanguageSelect";
import UserMenu from "./UserMenu";

export const drawerWidth = 280;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Header() {
  const open = useAppSelector((state) => state.drawer.open);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isAuthenticated } = useAppSelector((s) => s.auth);

  return (
    <AppBar position="absolute" open={open}>
      <Toolbar
        sx={{
          pr: "24px", // keep right padding when drawer closed
        }}
      >
        {isAuthenticated && (
          <IconButton
            edge="start"
            color="#0069b4"
            aria-label="open drawer"
            onClick={() => dispatch(toggleDrawer())}
            sx={{
              marginRight: "36px",
            }}
          >
            <MenuIcon />
          </IconButton>
        )}
        {isAuthenticated && (
          <Typography
            component="div"
            sx={{ flexGrow: 1 }}
            style={{ color: "#0069b4" }}
          >
            {t("dmy_ise_alim")}
          </Typography>
        )}
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        ></Typography>
        {isAuthenticated && <UserMenu />}
        <LanguageSelect />
      </Toolbar>
    </AppBar>
  );
}
